import styled from '@emotion/styled';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { withStyles } from '@material-ui/core/styles';
import theme from '../../themes/default';

export const StyledAccordion = styled(MuiAccordion)`
  margin: 0;
  box-shadow: none;
  border-radius: ${theme.borderRadius.medium};
  background-color: ${theme.color.designSystem.grey10};
  font-weight: ${theme.font.weight.regular};
  font-size: ${theme.font.size.copy};
  line-height: ${theme.font.lineHeight.copy};

  &::before {
    height: 0;
  }

  &.Mui-expanded {
    margin: 0;
  }
`;

// Use Mui styling in order to correctly apply styles to summary content
export const AccordionSummary = withStyles({
  root: {
    minHeight: 'unset',
    padding: 0,
    borderRadius: theme.borderRadius.medium,
    '&:hover': {
      backgroundColor: theme.color.designSystem.background.grey.hover,
    },
    '&.Mui-expanded': {
      minHeight: 'unset',
    },
    '&.Mui-focused': {
      backgroundColor: theme.color.grey14,
    },
    '&.MuiAccordion-rounded': {
      borderRadius: theme.borderRadius.medium,
    },
  },
  content: {
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    '&.Mui-expanded': {
      margin: '0',
    },
  },
})(MuiAccordionSummary);

export const AccordionDetails = styled(MuiAccordionDetails)`
  padding: 0 ${theme.spacing.large};
  margin-bottom: ${theme.spacing.xSmall};
`;

export const AccordionContent = styled('div')`
  border-left: 1px solid ${theme.color.blackAlpha(0.12)};
  padding-left: ${theme.spacing.xSmall};
  width: 100%;
`;

export const IconWrapper = styled.div`
  height: ${theme.spacing.xxxxLarge};
  width: ${theme.spacing.xxxxLarge};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ArrowIcon = styled(ArrowRightIcon, {
  shouldForwardProp: (prop) => prop !== 'isOpen',
})`
  color: ${theme.color.blackAlpha(0.6)};
  fontsize: ${theme.spacing.xLarge};

  &:hover: {
    color: ${theme.color.designSystem.purple70};
  }

  transition: transform 275ms;

  ${({ isOpen }) => isOpen && 'transform: rotate(90deg);'};
`;
